import CalendarEventViewModel from "./CalendarDayViewModel";

export default class CalendarViewModel {
    public startDayOfWeekIndex: number = 0;
    public events: CalendarEventViewModel[] = [];
}